import React, { Component } from 'react'
import { Line, Chart } from 'react-chartjs-2'
import { format } from 'date-fns'
import { thousandSeparator } from '../../../utils/Utils'
import 'chartjs-plugin-style'

class MChartDemo extends Component {
  state = {
    ticks: {
      labels: [],
      datasets: [
        {
          label: 'График',
          fill: this.props.fill,
          lineTension: 0.1,
          backgroundColor: this.props.chartColorFill,
          borderColor: this.props.chartColor,
          borderCapStyle: 'butt',
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: 'miter',
          pointBorderColor: this.props.chartColor,
          pointBackgroundColor: this.props.chartColor,
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: this.props.chartColor,
          pointHoverBorderColor: this.props.chartColor,
          pointHoverBorderWidth: 2,
          pointRadius: 1,
          pointHitRadius: 8,
          data: [],
          borderWidth: 2,
          lineTension: 0,
        },
      ],
    },
  }

  componentDidMount() {
    const values = this.props.data.map(({ value }) => value)
    const times = this.props.data.map(({ time }) => format(time, 'DD.MM'))

    const { verticalLineColor = '#8866ff' } = this.props

    Chart.pluginService.register({
      beforeDraw: function(chart, easing) {
        if (
          chart.tooltip._active &&
          chart.tooltip._active.length &&
          chart.config.type !== 'bar'
        ) {
          const activePoint = chart.controller.tooltip._active[0]
          const ctx = chart.ctx
          const x = activePoint.tooltipPosition().x
          const topY = chart.scales['y-axis-0'].top
          const bottomY = chart.scales['y-axis-0'].bottom
          ctx.save()
          ctx.beginPath()
          ctx.moveTo(x, topY)
          ctx.lineTo(x, bottomY)
          ctx.lineWidth = 0.5
          ctx.strokeStyle = verticalLineColor
          ctx.stroke()
          ctx.restore()
        }
      },
    })

    this.setState({
      ticks: {
        labels: times,
        datasets: [
          {
            ...this.state.ticks.datasets[0],
            label: this.props.label,
            data: values,
          },
        ],
      },
    })
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.data !== this.props.data) {
      const values = this.props.data.map(({ value }) => value)
      const times = this.props.data.map(({ time }) => format(time, 'DD.MM'))
      this.setState({
        ticks: {
          labels: times,
          datasets: [
            {
              ...this.state.ticks.datasets[0],
              label: this.props.label,
              data: values,
            },
          ],
        },
      })
    }
  }

  render() {
    const { ticks } = this.state
    const {
      symbol,
      showLegend,
      positionLegend,
      labelFontColor,
      fontColor,
      showGridline,
      gridLinesColor,
      zeroLineColor,
    } = this.props

    const options = {
      maintainAspectRatio: false,
      legend: {
        display: showLegend,
        align: 'start',
        position: positionLegend ? positionLegend : 'top',
        labels: {
          fontColor: labelFontColor,
          fontSize: 16,
        },
      },
      scales: {
        yAxes: [
          {
            ticks: {
              min: 0,
              precision: 0,
              maxTicksLimit: 4,
              type: 'logarithmic',
              beginAtZero: false,
              fontFamily: "'Exo 2', 'Helvetica', 'Arial'",
              fontSize: 10,
              fontColor: fontColor,
              callback: function(value, index, values) {
                return value >= 1000 ? value / 1000 + ' тыс.' : value
              },
            },
            gridLines: {
              display: showGridline,
              color: gridLinesColor,
              zeroLineColor: zeroLineColor,
            },
          },
        ],
        xAxes: [
          {
            ticks: {
              precision: 0,
              maxTicksLimit: 8,
              beginAtZero: false,
              fontFamily: "'Exo 2', 'Helvetica', 'Arial'",
              maxRotation: 0,
              minRotation: 0,
              fontColor: fontColor,
            },
            gridLines: {
              display: false,
              color: gridLinesColor,
              zeroLineColor: zeroLineColor,
            },
          },
        ],
      },
      tooltips: {
        caretSize: 0,
        displayColors: true,
        mode: 'index',
        intersect: false,
        titleFontFamily: "'Exo 2', 'Helvetica', 'Arial'",
        titleFontSize: 14,
        titleFontColor: '#000',
        titleFontStyle: 'normal',
        titleMarginBottom: 10,
        bodyAlign: 'left',
        bodyFontColor: '#979797',
        bodyFontSize: 12,
        bodyFontFamily: "'Exo 2', 'Helvetica', 'Arial'",
        backgroundColor: '#ffffff',
        shadowOffsetX: 0,
        shadowOffsetY: 16,
        shadowBlur: 32,
        shadowColor: 'rgba(0, 0, 0, 0.12)',
        caretPadding: 15,
        callbacks: {
          label: function(tooltipItem, data) {
            const label = data.datasets[tooltipItem.datasetIndex].label || ''
            return `${label}:  ${thousandSeparator(tooltipItem.value)} ${
              symbol ? symbol : ''
            }`
          },
        },
        hover: {
          mode: 'index',
          intersect: false,
        },
      },
    }

    return <Line ref="chart" data={ticks} options={options} />
  }
}

export default MChartDemo
